import React, {useEffect, useRef, useState} from 'react';

import {Events} from 'src/analytics';

import {SanityGlobalPodcastList} from 'graphql-types';
import {Maybe} from 'types/generated';

interface PodcastModalProps {
  globalPodcastContent: SanityGlobalPodcastList;
}

const trackPodcastSubscribe = (medium: string, form: string, section: string) => {
  Events.didSubscribePodcast({medium, form, section});
};

export const PodcastModal: React.FC<PodcastModalProps> = props => {
  const [isActive, setActive] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  useOutsideAlerter(ref);

  function useOutsideAlerter(ref: React.RefObject<HTMLDivElement>) {
    useEffect(() => {
      function handleClickOutside(event: {target: any}) {
        if (ref.current && !ref.current.contains(event.target)) {
          setActive(false);
        }
      }
      document.addEventListener('mousedown', handleClickOutside);
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }, [ref]);
  }

  const toggleClass = () => {
    setActive(!isActive);
  };
  const linkCount = props.globalPodcastContent?.podcastLinks?.length || 0;
  const gridCols = linkCount > 4 ? 'grid-cols-4' : `grid-cols-${linkCount}`;
  return (
    <div className="w-full flex items-center justify-center relative" ref={ref}>
      <button className={`button relative ${isActive ? 'subscribe-arrow-open' : null}`} onClick={toggleClass}>
        Follow Now
      </button>
      <div
        className={`rounded-md drop-shadow-xl bg-white py-5 px-7 absolute top-0 z-10 ${
          isActive ? 'subscribe-menu-open' : 'hidden'
        }`}
      >
        <h3 className="type-theta mb-4 text-black">Follow {props.globalPodcastContent?.title}</h3>
        <div className={`grid ${gridCols} gap-x-2 gap-y-2 md:gap-2 items-center`}>
          <>
            {props.globalPodcastContent?.podcastLinks &&
              props.globalPodcastContent?.podcastLinks?.map(item => {
                return (
                  <>
                    <a
                      key={item?._key}
                      href={item?.podcastUrl || ''}
                      target="_blank"
                      rel="noreferrer"
                      onClick={() =>
                        trackPodcastSubscribe(
                          `${item?.podcastName || 'Apple'} Podcast`,
                          'Follow Podcast Modal',
                          'Podcast Subscribe Modal',
                        )
                      }
                      className="flex col-span-2 md:col-span-1 button-outline group justify-center items-center group-subscribe-item hover:bg-beige"
                    >
                      {item?.podcastIcon?.asset?.url && (
                        <object type="image/svg+xml" data={item.podcastIcon.asset.url} className="icon"></object>
                      )}{' '}
                      <span className="ml-2 block text-black">{item?.podcastName}</span>
                    </a>
                  </>
                );
              })}
          </>
        </div>
      </div>
    </div>
  );
};
